
/**
 * 是否外部链接
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|http:|mailto:|tel:)/.test(path);
}

/**
 * 验证链接地址
 * @param {string} url
 * @returns {Boolean}
 */
function isURL(url) {
  const reg = /^(https?|ftp|http):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * 验证小写字母
 * @param {string} str
 * @returns {Boolean}
 */
function isLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}


/**
 * 验证正整数
 * @param {string} str
 * @returns {Boolean}
 */
function isInteger(str) {
  const reg = /^[1-9]\d*$/;
  return reg.test(str);
}

/**
 * 验证大写字母
 * @param {string} str
 * @returns {Boolean}
 */
function isUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * 验证英文字母
 * @param {string} str
 * @returns {Boolean}
 */
function isAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * 验证英文数字
 * @param {string} str
 * @returns {Boolean}
 */
function isNumberAlphabet(str) {
  const reg = /^[A-Za-z0-9]+$/;
  return reg.test(str);
}

/**
 * 验证邮箱
 * @param {string} str
 * @returns {Boolean}
 */
function isEmail(str) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str);
}

/**
 * 是否字符类型
 * @param {string} str
 * @returns {Boolean}
 */
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * 是否数组类型
 * @param {Array} arg
 * @returns {Boolean}
 */
function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}

/**
 * 是否手机号码
 * @param {string} str
 * @returns {Boolean}
 */
function isMobile(str) {
  const reg = /^([0-9]{1,5}|0)?1([3|4|5|7|8])+([0-9]){9,10}$/;
  return reg.test(str);
}

/**
 * 是否微信号
 * @param {string} str
 * @returns {Boolean}
 */
function isWechatID(str) {
  const reg = /(^[a-zA-Z][a-zA-Z\d_-]{5,19}$)|(^1[3456789]\d{9}$)/;
  return reg.test(str);
}

/**
 * 验证用户密码
 * @param {string} str
 * @returns {Boolean}
 */
function isPassword(str) {
  const reg = /^(?=.*?[0-9])(?=.*?[a-zA-Z])([\w_\-@&=\*\$!^%\(\)]{8,30})$/;
  return reg.test(str);
}

/**
 * 是否为空
 * @param {string} str
 * @returns {Boolean}
 */
function isEmpty(str) {
  if (typeof str == "undefined" || str == null || str == "" || str == 'undefined') {
    return true;
  } else {
    return false;
  }
}

/**
 * 是否金额
 * @param {string} str
 * @returns {Boolean}
 */
function isAmount(str) {
  str = str.toString()
  const reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
  return reg.test(str);
}

export default {
  isExternal,
  isURL,
  isLowerCase,
  isInteger,
  isUpperCase,
  isAlphabets,
  isNumberAlphabet,
  isEmail,
  isString,
  isArray,
  isMobile,
  isWechatID,
  isPassword,
  isEmpty,
  isAmount
}


// WEBPACK FOOTER //
// ./src/utils/validate.js